export default "__VITE_ASSET__CsdDxz8k__"